import { Component, EventEmitter, Input, Output } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-cast-error',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './cast-error.component.html',
  styleUrls: ['./cast-error.component.scss'],
})
export class CastErrorComponent {
  @Input() title!: string
  @Input() message?: string
  @Output() doBack = new EventEmitter()
  @Output() doClose = new EventEmitter()

  constructor() {
    // do nothing
  }
}
